import { Link } from 'react-router-dom';
import './styles.css';

export default function LessonCard({ lesson }) {
  return (
    <Link to={`/lesson-plans/${lesson.id}`} className="lesson-card">
      <div className="lesson-card-content">
        <h3 className="lesson-title">{lesson.name}</h3>
      </div>
    </Link>
  );
}
